import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home.vue'
import Broadcasts from '@/views/Broadcasts.vue'
import BroadcastDetail from '@/views/BroadcastDetail.vue'
import Parts from '@/views/Parts.vue'
import PartsDetail from '@/views/PartsDetail.vue'
import PartLanding from '@/views/PartLanding.vue'
import Companies from '@/views/Companies.vue'
import CompanyDetail from '@/views/CompanyDetail.vue'
import Inventory from '@/views/Inventory.vue'
import InventoryHits from '@/views/InventoryHits.vue'

import Profile from '@/views/Profile.vue'
import Invoices from '@/views/Invoices.vue'

import TestimonialsPage from '@/views/TestimonialsPage.vue'
import FreeTrial from '@/views/FreeTrial.vue'
import News from '@/views/News.vue'
import About from '@/views/About.vue'
import Contact from '@/views/Contact.vue'
import Help from '@/views/Help.vue'

import Payment from '@/views/Payment.vue'
import Contract from '@/views/Contract.vue'
import Mediakit from '@/views/Mediakit.vue'
import Newsletter from '@/views/Newsletter.vue'
import Services from '@/views/Services.vue'
import ServiceCategory from '@/views/ServiceCategory.vue'
import ServiceCompany from '@/views/ServiceCompany.vue'
import Privacy from '@/views/Privacy.vue'

import BroadcastRules from '@/views/BroadcastRules.vue'
import BroadcastSettings from '@/views/BroadcastSettings.vue'
import GradingGuidelines from '@/views/GradingGuidelines.vue'
import RSS from '@/views/RSS.vue'

///media kit sublevels
import AboutTBS from '@/views/mediakit/AboutTBS.vue'
import AboutEBM from '@/views/mediakit/AboutEBM.vue'
import Advertising from '@/views/mediakit/Advertising.vue'
import Social from '@/views/mediakit/Social.vue'
import Videos from '@/views/mediakit/Videos.vue'

import DiamondMembers from '@/views/MembersDiamond.vue'
import GoldMembers from '@/views/MembersGold.vue'
import TrustedMembers from '@/views/MembersTrusted.vue'

import Favorites from '@/views/Favorites.vue'

import TwoFactorAuth from '@/views/TwoFactorAuth.vue'
import AdvertisementRedirect from '../views/AdvertisementRedirect.vue'
import Escrow from '../views/Escrow.vue'
import Sandbox from '../views/Sandbox.vue'
import PurchaseOrderCreate from '../views/PurchaseOrderCreate.vue'


import PageNotFound from '@/views/PageNotFound.vue'

import store from '../store'
import { buildSeoLandingRoutes } from '@/content/broadcastSeoLandings'
import { property } from 'lodash'
import BroadcastPictures from '@/views/BroadcastPictures.vue'


const TITLE_SUFFIX = "The Broker Site";

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: `${TITLE_SUFFIX} Home - Empowering the Circular IT Industry since 1999`,
      metaTags: [
         {
           name: 'description',
           content: `Empowering the Circular IT Industry since 1999. The Broker Site is the leading B2B marketplace for the Circular IT Industry.`
         },
         {
           // property: 'og:description',
           // content: 'The home page of our example app.'
           name: 'keywords',
           content: 'Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
          },
          {
            name: 'robots',
            content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
          },
          {
            rel: 'canonical',
            href: 'https://www.thebrokersite.com'
          }
       ]
    }
  },
  {
    path: '/escrow',
    name: 'escrow',
    component: Escrow,
    meta: {
      title: `Initiate Escrow.com Transaction on TheBrokerSite`,
      metaTags: [
        {
          name: 'description',
          content: 'Initiate a secure Escrow.com transaction. Safely buy and sell IT hardware, electronics, and B2B goods with trusted escrow protection for buyers and sellers'
        },
        {
          name: 'keywords',
          content: 'escrow, escrow.com, secure escrow, escrow transaction, buyer seller protection, B2B escrow, IT hardware escrow, electronics escrow, trusted transactions, TheBrokerSite, brokers, marketplace escrow, safe payments'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
      ]
    },
  },
  {
    path: '/purchase-orders/create',
    name: 'purchase-orders.create',
    component: PurchaseOrderCreate,
    meta: {
      title: 'Create Purchase Order on The Broker Site',
      metaTags: [
        {
          name: 'description',
          content: 'Create and send purchase orders for IT hardware and electronic components. Streamline B2B procurement with The Broker Site.'
        },
        {
          name: 'keywords',
          content: 'purchase order, create purchase order, PO, procurement, B2B purchasing, IT hardware, electronic components, computer parts, supplier, buyer, purchasing, sourcing, The Broker Site'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
      ]
    },
  },

  {
    path: '/broadcasts',
    name: 'broadcasts',
    component: Broadcasts,
    meta: {
      title: `Broadcasts - Search, Post, and Find WTB and WTS Deals`,
      metaTags: [
        {
          name: 'description',
          content: 'Broadcasts from our members looking for (WTB) or offering (WTS) deals. Search, Post, and Find WTB and WTS Deals'
        },
        {
          name: 'keywords',
          content: 'Broadcasts, Members, Lists, PC, Networking, Laptop, Printer, Server, Storage, Telecom, Tablet, POS, Electronics, GSM, Mobile, Monitor, Software, Components, WTB, WTS, Deals, Offers, Requests, Search, Post, Find'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/broadcasts'
        }
    ]
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "broadcasts" */ '../views/Broadcasts.vue')
  },
  {
    path: '/broadcasts/:id(\\d+)',
    name: 'broadcasts',
    component: BroadcastDetail,
    meta: {
      title: `Broadcast Details - Search, Post, and Find WTB and WTS Deals`,
      metaTags: [
        {
          name: 'description',
          content: 'Broadcast details for a specific broadcast. Search, Post, and Find WTB and WTS Deals'
        },
        {
          name: 'keywords',
          content: 'Broadcast, Details, WTB, WTS, Deals, Offers, Requests, Search, Post, Find'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/broadcasts'
        }
      ]
    },
  },
  {
    path: '/broadcasts/:id(\\d+)/pictures',
    name: 'broadcasts pictures',
    component: BroadcastPictures,
    meta: {
      title: `Broadcast Pictures`,
      metaTags: [
        {
          name: 'keywords',
          content: 'Broadcast, Details, WTB, WTS, Deals, Offers, Requests, Search, Post, Find'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
      ]
    },
  },
  ...buildSeoLandingRoutes(Broadcasts, store),
  {
    path: '/broadcasts/:category/:type?',
    name: 'broadcasts',
    component: Broadcasts,
    meta: {
      title: `Broadcasts - Search, Post, and Find WTB and WTS Deals`,
      metaTags: [
        {
          name: 'description',
          content: 'Broadcasts from our members looking for (WTB) or offering (WTS) deals. Search, Post, and Find WTB and WTS Deals'
        },
        {
          name: 'keywords',
          content: 'Broadcasts, Members, Lists, PC, Networking, Laptop, Printer, Server, Storage, Telecom, Tablet, POS, Electronics, GSM, Mobile, Monitor, Software, Components, WTB, WTS, Deals, Offers, Requests, Search, Post, Find'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/broadcasts'
        }
    ]
    },
  },
  {
    path: '/parts',
    name: 'parts',
    component: Parts,
    meta: {
      title: `Parts Search - Browse for parts offered by our members`,
      metaTags: [
        {
          name: 'description',
          content: 'Browse for parts offered by our members, or use keyword searches to find what you need. Parts Search'
        },
        {
          name: 'keywords',
          content: 'Parts, Search, Result, Found, Companies, RFQ, Listing, Advertise, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/parts'
        }
      ]
    },
  },
  {
    path: '/parts/:id',
    name: 'parts',
    component: PartsDetail,
    meta: {
      title: `Part Details - Browse for parts offered by our members`,
      metaTags: [
        {
          name: 'description',
          content: 'Details for an item as searched. Browse for parts offered by our members, or use keyword searches to find what you need'
        },
        {
          name: 'keywords',
          content: 'Parts, Details, Searched, RFQ, Company, Companies, Listing, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/parts'
        }
      ]
    },
  },
  {
    path: '/companies',
    name: 'companies',
    component: Companies,
    meta: {
      title: `Companies - Browse, search, or explore the world map to find our members`,
      metaTags: [
        {
          name: 'description',
          content: 'Browse through, use keyword searches, or explore the world map to find our verified members through the Company Search. Companies'
        },
        {
          name: 'keywords',
          content: 'TBS, Company, Search, Find, Members, Trusted, Gold, Diamond, World, Europe, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/companies'
        }
      ]
    },
  },
  {
    path: '/companies/:id',
    name: 'companyDetail',
    component: CompanyDetail,
    meta: {
      title: `Company Details - Browse, search, or explore the world map to find our members`,
      metaTags: [
        {
          name: 'description',
          content: 'Details for a company as searched. Browse through, use keyword searches, or explore the world map to find our verified members through the Company Search'
        },
        {
          name: 'keywords',
          content: 'Details, Company, Search, Find, Members, Trusted, Gold, Diamond, World, Europe, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/companies'
        }
      ]
    },
  },
  {
    path: '/inventory',
    name: 'inventory',
    component: Inventory,
    meta: {
      title: `My Inventory - Add to, modify or delete from your currently listed inventory`,
      metaTags: [
        {
          name: 'description',
          content: 'Your currently listed inventory. Add to, modify or delete from your currently listed inventory. My Inventory'
        },
        {
          name: 'keywords',
          content: 'Inventory, Items, Parts, Manufacturer, Description, Quantity, Condition, Price, My, Inventory, Add, Modify, Delete, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/inventory'
        }
      ]
    },
  },
  {
    path: '/inventory-hits',
    name: 'inventoryHits',
    component: InventoryHits,
    meta: {
      title: `Inventory hits`,
      metaTags: [
        {
          name: 'description',
          content: 'Check the hits your inventory has received'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          name: 'keywords',
          content: 'Inventory, Items, Parts, Manufacturer, Description, Quantity, Condition, Price, Hits, List, TBS'
        }
      ]
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      title: `My Profile - Modify your profile details, upload your profile picture, and more`,
      metaTags: [
        {
          name: 'description',
          content: 'Your profile on www.TheBrokerSite.com. Modify your profile details, upload your profile picture, and more. My Profile'
        },
        {
          name: 'keywords',
          content: 'Profile, Company, Gold, Trusted, Diamond, Members, Contact, Persons, Details, Telephone, Email, My, Profile, Modify, Upload, Picture, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/profile'
        }
      ]
    },
  },
  {
    path: '/invoices',
    name: 'invoice',
    component: Invoices,
    meta: {
      title: `Billing History - View your invoices, and pay your invoices`,
      metaTags: [
        {
          name: 'description',
          content: 'Your invoice listing. View your invoices, and pay your invoices. Billing History'
        },
        {
          name: 'keywords',
          content: 'Invoice, Listing, View, Pay, Invoices, History, TBS, Billing, History, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/invoices'
        }
      ]
    },
  },
  {
    path: '/testimonials',
    name: 'testimonials',
    component: TestimonialsPage,
    meta: {
      title: 'Testimonials from Brokers Worldwide | TheBrokerSite.com',
      metaTags: [
        {
          name: 'description',
          content: 'Read authentic testimonials from members of TBS. Discover why brokers worldwide trust our platform for secure trading, networking, and business growth.'
        },
        {
          name: 'keywords',
          content: 'Testimonials, Members, TBS, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport  '
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/testimonials'
        }
      ]
    },
  },
  {
    path: '/register',
    name: 'freeTrial',
    component: FreeTrial,
    meta: {
      title: `Register for a Free Trial - Sign up now for a FREE 1-month trial`,
      metaTags: [
        {
          name: 'description',
          content: 'Sign up now for a FREE 1-month trial of www.TheBrokerSite.com. Register for a Free Trial'
        },
        {
          name: 'keywords',
          content: 'Free, Trial, One, Month, 1, TBS, Membership, Register, Free, Trial, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport  '
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/register'
        }
      ]
    },
  },
  {
    path: '/news',
    name: 'news',
    component: News,
    children: [
      {
        path: ':categoryName',
        component: News,
        props: true,
      },
    ],
    meta: {
      title: `News - The latest news and updates from The Broker Site`,
      metaTags: [
        {
          name: 'description',
          content: 'The latest news and updates from The Broker Site. News'
        },
        {
          name: 'keywords',
          content: 'Fraud, Cheat, Payer, Bad, New, Trusted, Gold, Members, European, Broker, Meeting, Events, News, Updates, TBS, News, Updates, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/news'
        }
      ]
    },
  },
  {
    path: '/news/:category/:slug',
    name: 'newsDetail',
    props: (route) => ({
      id: route.params.id,
      category: route.params.category,
      slug: route.params.slug
    }),
    component: News,
    meta: {
      metaTags: [
        {
          property: 'og:type',
          content: 'article'
        },
        {
          property: 'og:url',
          content: 'https://www.thebrokersite.com/news'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/news'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
      ]
    }
  },

  {
    path: '/about',
    name: 'about',
    component: About,
    meta: {
      title: `About - All you need to know about www.TheBrokerSite.com`,
      metaTags: [
        {
          name: 'description',
          content: 'How verification, grading and safe-trading rules help brokers trade refurbished PCs, laptops, servers & parts with confidence'
        },
        {
          name: 'keywords',
          content: 'TBS, Gold, Trusted, Diamond, Network, Safe, Trading, Frauds, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/about'
        }
      ]
    },
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {
      title: `Contact us. We are here to help you with any questions you may have.`,
      metaTags: [
        {
          name: 'description',
          content: 'Contact us at The Broker Site. We are here to help you with any questions you may have.'
        },
        {
          name: 'keywords',
          content: 'TBS, Contact, name, email, telephone, address, postal code, city, country, company, company name, company address, company postal code, company city, company country'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/contact'
        }
      ]
    },
  },
  {
    path: '/help',
    name: 'help',
    component: Help,
    meta: {
      title: `Help and FAQs - Learn how to use the different features and functions of TheBrokerSite.com and maximize it for your business!`,
      metaTags: [
        {
          name: 'description',
          content: 'Learn how to use the different features and functions of TheBrokerSite.com and maximize it for your business! Help and FAQs'
        },
        {
          name: 'keywords',
          content: 'TBS, Help, Tutorials, Videos, How, To, RSS, Subscribe, Company, Companies, Inventory, Parts, Search, FAQs, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/help'
        }
      ]
    },
  },
  {
    path: '/help/:slug',
    name: 'help-slug',
    component: Help,
    meta: {
      title: `Help and FAQs - Learn how to use the different features and functions of TheBrokerSite.com and maximize it for your business!`,
      metaTags: [
        {
          name: 'description',
          content: 'Learn how to use the different features and functions of TheBrokerSite.com and maximize it for your business! Help and FAQs'
        },
        {
          name: 'keywords',
          content: 'TheBrokerSite, Help, Tutorials, FAQs, B2B Marketplace, Company, Inventory, Parts, Broadcasts'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/help'
        }
      ]
    }
  },
  {
    path: '/rss',
    name: 'rss',
    component: RSS,
    meta: {
      title: `RSS - Subscribe to our RSS feed to get the latest news and updates from TheBrokerSite.com`,
      metaTags: [
        {
          name: 'description',
          content: 'Subscribe to our RSS feed to get the latest news and updates from TheBrokerSite.com. RSS'
        },
        {
          name: 'keywords',
          content: 'Subscribe, RSS, Feed, News, Updates, TheBrokerSite, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/rss'
        }
      ]
    },
  },

  //Footer
  {
    path: '/payment',
    name: 'payment',
    component: Payment,
    meta: {
      title: `Payment - Pay for your TBS Membership per year online via Credit Card or Invoice`,
      metaTags: [
        {
          name: 'description',
          content: 'Pay for your TBS Membership per year online via Credit Card or Invoice. Payment'
        },
        {
          name: 'keywords',
          content: 'TBS, Pay, Credit, Card, Cash, Invoice, Wire, Transfer, Membership, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/payment'
        }
      ]
    },
  },
  {
    path: '/contract',
    name: 'contract',
    component: Contract,
    meta: {
      title: `Terms and Conditions - Please make sure you read and agree to the Terms and Conditions before you register`,
      metaTags: [
        {
          name: 'description',
          content: 'Please make sure you read and agree to the Terms and Conditions before you register. Terms and Conditions'
        },
        {
          name: 'keywords',
          content: 'Contract, Terms, Read, Agree, Register, TBS, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/contract'
        }
      ]
    },
  },
  {
    path: '/media-kit',
    name: 'mediakit',
    component: Mediakit,
    meta: {
      title: `Media Kit - Download the Media Kit, and use it to promote The Broker Site`,
      metaTags: [
        {
          name: 'description',
          content: 'The TBS Media Kit. Download the Media Kit, and use it to promote The Broker Site. Media Kit'
        },
        {
          name: 'keywords',
          content: 'Media Kit, Download, Promote, The Broker Site, TBS, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/media-kit'
        }
      ]
    },
   
  },
  {
    path: '/newsletter',
    name: 'newsletter',
    component: Newsletter,
    meta: {
      title: `Newsletter - Subscribe to our newsletter to get the latest news and updates from TheBrokerSite.com`,
      metaTags: [
        {
          name: 'description',
          content: 'Subscribe to our newsletter to get the latest news and updates from TheBrokerSite.com. Newsletter'
        },
        {
          name: 'keywords',
          content: 'Subscribe, Newsletter, The Broker Site, TBS, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/newsletter'
        }
      ]
    },
   
  },
  {
    path: '/services',
    name: 'services',
    component: Services,
    meta: {
      title: `Services - Directory of services offered by TBS Members`,
      metaTags: [
        {
          name: 'description',
          content: 'Find certified partners for asset recovery, data sanitization, testing,grading, repair and remarketing across Europe.'
        },
        {
          name: 'keywords',
          content: 'TBS, Services, Members, Data, Erasure, Transport, Keyboard, Printing, Packaging, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/services'
        }
      ]
    },
  },
  {
    path: '/services/:categorySlug',
    name: 'serviceCategory',
    component: ServiceCategory,
    meta: {
      title: `Services - The Broker Site`,
      metaTags: [
        {
          name: 'description',
          content: 'Browse service providers listed on The Broker Site.'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
      ]
    },
  },
  {
    path: '/services/:categorySlug/:companySlug',
    name: 'serviceCompany',
    component: ServiceCompany,
    meta: {
      title: `Service Provider - The Broker Site`,
      metaTags: [
        {
          name: 'description',
          content: 'Service provider profile listed on The Broker Site.'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
      ]
    },
  },
  {
    path: '/media-kit/about-tbs',
    name: 'mediakit',
    component: AboutTBS,
    meta: {
      title: `About TBS - A ll you need to know about www.TheBrokerSite.com`,
      metaTags: [
        {
          name: 'description',
          content: 'About The Broker Site. How it works, The Network, Safe Trading, Trusted, Gold and Diamond Members, all you need to know about www.TheBrokerSite.com. About TBS'
        },
        {
          name: 'keywords',
          content: 'About, The Broker Site, How, works, The, Network, Safe, Trading, Trusted, Gold, Diamond, Members, all, need, know, www.TheBrokerSite.com, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/media-kit/about-tbs'
        }
      ]
    },
  },
  {
    path: '/media-kit/about-ebm',
    name: 'mediakit',
    component: AboutEBM,
    meta: {
      title: `About the European Broker Meeting - A yearly event that brings together traders from all over the world`,
      metaTags: [
        {
          name: 'description',
          content: 'About the European Broker Meeting. The European Broker Meeting is a yearly event that brings together traders from all over the world. About the European Broker Meeting'
        },
        {
          name: 'keywords',
          content: 'About, the, European, Broker, Meeting, The, European, Broker, Meeting, is, a, yearly, event, that, brings, together, traders, from, all, over, the, world, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/media-kit/about-ebm'
        }
      ]
    },
  },
  {
    path: '/media-kit/advertising',
    name: 'mediakit',
    component: Advertising,
    meta: {
      title: `Advertise on The Broker Site to reach our audience of traders and brokers`,
      metaTags: [
        {
          name: 'description',
          content: 'Advertising on The Broker Site. Advertise on The Broker Site to reach our audience of traders and brokers. Advertising on The Broker Site'
        },
        {
          name: 'keywords',
          content: 'Advertising, The Broker Site, Advertise, Reach, Audience, Traders, Brokers, TBS, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/media-kit/advertising'
        }
      ]
    },
  },
   {
    path: '/media-kit/social',
    name: 'mediakit',
    component: Social,
    meta: {
      title: `Social Media - Follow us on social media to get the latest from The Broker Site`,
      metaTags: [
        {
          name: 'description',
          content: 'Social Media for The Broker Site. Follow us on social media to get the latest news and updates from The Broker Site. Social Media'
        },
        {
          name: 'keywords',
          content: 'Social Media, The Broker Site, Follow, Latest, News, Updates, TBS, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/media-kit/social'
        }
      ]
    },
  },
   {
    path: '/media-kit/videos',
    name: 'mediakit',
    component: Videos,
    meta: {
      title: `Videos - Watch our videos to learn more about The Broker Site`,
      metaTags: [
        {
          name: 'description',
          content: 'Videos from The Broker Site. Watch our videos to learn more about The Broker Site. Videos'
        },
        {
          name: 'keywords',
          content: 'Videos, The Broker Site, Watch, Learn, More, TBS, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/media-kit/videos'
        }
      ]
    },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
    meta: {
      title: `Privacy and Cookies Policy - Make sure to read the Privacy and Cookies Policy before using our website`,
      metaTags: [
        {
          name: 'description',
          content: 'Privacy and Cookies Policy for www.TheBrokerSite.com. Make sure to read the Privacy and Cookies Policy before using our website'
        },
        {
          name: 'keywords',
          content: 'TBS, The, Broker, Site, Privacy, Policy, Disclaimer, Read, Use, Website, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/privacy'
        }
      ]
    },
  },

  {
    path: '/broadcast-rules',
    name: 'broadcastRules',
    component: BroadcastRules,
    meta: {
      title: `Broadcast Rules - Make sure to read the Broadcast Rules before posting a broadcast`,
      metaTags: [
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
      ]
    },
  },
   {
    path: '/broadcast-settings',
    name: 'broadcastSettings',
    component: BroadcastSettings,
    meta: {
      title: `Broadcast Settings - Make sure to read the Broadcast Settings before posting a broadcast`,
    },
  },
  {
    path: '/grading-guidelines',
    name: 'gradingGuidelines',
    component: GradingGuidelines,
    meta: {
      title: `Grading Guidelines - Make sure to read the Grading Guidelines before posting a broadcast`,
      metaTags: [
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
      ]
    },
  },
  {
    path: '/diamond-members',
    name: 'diamondMembers',
    component: DiamondMembers,
    meta: {
      title: `Diamond members - The best of the best`,
      metaTags: [
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
      ]
    },
  },
  {
    path: '/gold-members',
    name: 'goldMembers',
    component: GoldMembers,
    meta: {
      title: `Gold members - The best of the best`,
      metaTags: [
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
      ]
    },
  },
  {
    path: '/trusted-members',
    name: 'trustedMembers',
    component: TrustedMembers,
    meta: {
      title: `Trusted Members - The best of the best`,
      metaTags: [
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
      ]
    },
  },
  {
    path: '/favorites',
    name: 'favorites',
    component: Favorites,
    meta: {
      title: `Favorites - Details, parts, and broadcasts of your favorite TBS Members`,
      metaTags: [
        {
          name: 'description',
          content: 'Find and view the details, parts, and broadcasts of your favorite companies. Favorites'
        },
        {
          name: 'keywords',
          content: 'TBS, The, Broker, Site, Page, Part, Broadcast, Company, Favorites, Favorite, Companies, Parts, Broadcasts, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/favorites'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        }
      ]
    },
  },
  {
    path: '/2fa',
    name: 'twoFactorAuth',
    component: TwoFactorAuth,
    meta: {
      title: `Two-Factor Authentication (2FA) - Enable or disable 2FA on your account`,
      metaTags: [
        {
          name: 'description',
          content: 'Two-Factor Authentication (2FA) - Enable or disable 2FA on your account'
        },
        {
          name: 'keywords',
          content: 'Two-Factor Authentication (2FA), 2FA, Enable, Disable, Account, TBS, B2B, Marketplace, Circular, IT, Industry, since, 1999, B2B, used, computers, servers, traders, dealers, hardware, broadcasts, brokers, PC, Laptop, mobile, printer, tablet, gaming, monitors, keyboards, printers, packaging, data, erasure, transport'
        },
        {
          rel: 'canonical',
          href: 'https://www.thebrokersite.com/two-factor-auth'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
      ],
    },
  },
  {
    path: '/advertisement/:id',
    name: 'advertisementRedirect',
    component: AdvertisementRedirect,
    meta: {
      title: `Advertise Redirect`,
      metaTags: [
        {
          name: 'description',
          content: 'Advertise Redirect'
        },
        {
          name: 'robots',
          content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
        },
      ],
    },
  },
  {
    path: '/sandbox/inventory-api',
    name: 'Sandbox',
    component: Sandbox,
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: PartLanding,
    meta: {
      title: `Page not found`,
      metaTags: [
        {
          name: 'description',
          content: 'Page not found on www.TheBrokerSite.com'
        },
        {
          name: 'keywords',
          content: 'TBS, The, Broker, Site, Page, Part, Broadcast, Company, Not, Found'
        },
        // {
        //   name: 'robots',
        //   content: 'noindex'
        // }
      ]
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  //https://router.vuejs.org/guide/advanced/scroll-behavior.html
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      setTimeout(() => {
        const element = document.getElementById(to.hash.replace(/#/, ''))
        if (element) { //&& element.scrollIntoView
          element.scrollIntoView({block: 'end', behavior: 'smooth'})
        }
      }, 500)
    }
    return { x: 0, y: 0 }
  },
})

// Ignore NavigationDuplicated error to clean Sentry logs
const methods = ['push', 'replace']

methods.forEach(method => {
  const originalMethod = VueRouter.prototype[method]
  VueRouter.prototype[method] = function(location) {
    return originalMethod.call(this, location).catch(err => {
      if (err.name !== 'NavigationDuplicated') throw err
    })
  }
})

//FROM: https://www.digitalocean.com/community/tutorials/vuejs-vue-router-modify-head
// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
  Array.from(document.querySelectorAll('link[rel="canonical"]')).map(el => el.parentNode.removeChild(el));

  // This goes through the matched routes from last to first, finding the closest route with a title.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Add robots meta tag if it doesn't exist in the route's meta tags
  if (!nearestWithMeta.meta.metaTags.some(tag => tag.name === 'robots')) {
    nearestWithMeta.meta.metaTags.push({
      name: 'robots',
      content: 'index'
    });
  }

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement(tagDef.rel ? 'link' : 'meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

router.beforeEach((to, from, next) => {
  store.dispatch("getRandomBanners");

  // Check if we need to fetch unread news
  try {
      const lastNewsUpdate = localStorage.getItem('lastNewsUpdate');
      const newsUnread = localStorage.getItem('newsUnread');
      const currentTime = Date.now();
      const fiveMinutes = 5 * 60 * 1000; // 5 minutes in milliseconds
      
      // If no timestamp exists or it's older than 5 minutes, fetch new data
      if (!lastNewsUpdate || newsUnread === null || (currentTime - parseInt(lastNewsUpdate)) > fiveMinutes) {

          // Update timestamp first to prevent rapid consecutive calls
          localStorage.setItem('lastNewsUpdate', currentTime.toString());
          store.dispatch("getNewsUnread");
      }
  } catch (error) {
      store.dispatch("getNewsUnread");
  }

  store.dispatch("logPage", {path: to.fullPath});
  if (store.state.user) {
    store.dispatch("getLastInvoiceStatus");
  }

  // Google Analytics send manual pageview on each route-change
  window.gtag('event', 'page_view', {
    page_title: to.meta.title,
    page_location: to.fullPath,
    page_path: to.fullPath,
    send_to: 'G-VJ8LLCMQ7R'
  })

  next();
})


export default router
